import Vue from 'vue';

export const payrollOverviewDetailsService = {
  async retrievePayrollOverviewDetails(referenceNumber) {
    return Vue.axios.get(`/payroll-overviews/${referenceNumber}`).then(response => response.data);
  },
  async retrievePayrollOverviewTimesheets(referenceNumber, sortOrder, paginationParameters) {
    return Vue.axios
      .get(`/payroll-overviews/${referenceNumber}/time-sheets`, {
        params: {
          ...sortOrder,
          ...paginationParameters
        }
      })
      .then(response => response.data);
  },
  async retrievePayrollOverviewTimesheetsCount(referenceNumber) {
    return Vue.axios
      .get(`/payroll-overviews/${referenceNumber}/time-sheets-count`)
      .then(response => response.data);
  },
  async processResults(referenceNumber, fileName) {
    return Vue.axios
      .get(`/payroll-overviews/${referenceNumber}/process-payroll`, {
        params: {
          'file-name': fileName
        }
      })
      .then(response => response.data);
  }
};
